import { Link } from "react-router-dom";
import { Receipt, ArrowRight } from "lucide-react";
import Badge from "../../components/Badge";
import { formatCurrency } from "@/lib/data";
import { formatDate } from "@/lib/dateFormat";
import { Invoice } from "./types";

interface EventInvoicesProps {
  invoices: Invoice[];
}

export default function EventInvoices({ invoices }: EventInvoicesProps) {
  return (
    <div className="bg-white rounded-xl border border-stone-200 overflow-hidden shadow-sm">
      <div className="px-4 py-3 bg-gradient-to-r from-amber-50 to-amber-100/50 border-b border-amber-100 flex items-center justify-between">
        <h3 className="font-bold text-stone-800 text-sm flex items-center gap-2">
          <Receipt className="w-4 h-4 text-amber-600" />
          Invoices
          <span className="text-xs bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded-full font-medium">{invoices.length}</span>
        </h3>
        <Link to="/invoices" className="text-xs font-semibold text-amber-700 hover:text-amber-800 flex items-center gap-1 min-h-8">
          All invoices <ArrowRight className="w-3 h-3" />
        </Link>
      </div>

      {invoices.length === 0 ? (
        <div className="p-6 text-center">
          <Receipt className="w-10 h-10 text-stone-200 mx-auto mb-2" />
          <p className="text-sm text-stone-400">No invoice generated yet</p>
        </div>
      ) : (
        <div className="divide-y divide-stone-100">
          {invoices.map((inv) => (
            <div key={inv.id} className="p-3 flex items-center justify-between gap-3">
              <div className="min-w-0">
                <p className="text-sm font-semibold text-stone-800 truncate">{inv.invoice_number || `#${inv.id}`}</p>
                <p className="text-xs text-stone-500">
                  {inv.issue_date ? formatDate(inv.issue_date) : "No date"}
                  {inv.due_date && <> · due {formatDate(inv.due_date)}</>}
                </p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-sm font-semibold text-stone-800">
                  {formatCurrency(Number(inv.final_amount ?? inv.total_amount) || 0)}
                </p>
                <Badge label={inv.status} status={inv.status} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
